<template>
  <div :id="componentId" class="diagnosis-block">
    <h1 v-animate-onscroll.repeat="{ down: 'animated fadeInUpBig' }" class="diagnosis-title">
      {{ diagnosisBlockData.diagnosis_title }}
    </h1>
    <h2 v-animate-onscroll.repeat="{ down: 'animated fadeInUpBig' }" class="disgnosis-subtitle">
      {{ diagnosisBlockData.diagnosis_description }}
    </h2>
    <div
      v-if="diagnosisImage"
      v-animate-onscroll.repeat="{ down: 'animated zoomIn' }"
      class="diagnosis-image"
    >
      <img :src="diagnosisImage.Src" :alt="diagnosisImage.Alt" />
    </div>
    <a
      v-if="ctaButton"
      v-animate-onscroll.repeat="{ down: 'animated zoomIn' }"
      class="ripple-animation ripple-animation--black"
      :class="
        diagnosisBlockData.diagnosis_iscta_overlapped
          ? 'diagnosis-overlap-cta-button'
          : 'diagnosis-below-cta-button'
      "
      @click="openDiagnosticModel(ctaButton.Text)"
      >{{ ctaButton.Text }}</a
    >
  </div>
</template>

<script>
export default {
  name: 'diagnosis-block',
  props: {
    diagnosisBlockData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      componentId: 'diagnosis',
    };
  },
  computed: {
    diagnosisImage() {
      if (this.diagnosisBlockData.diagnosis_Image) {
        return this.diagnosisBlockData.diagnosis_Image;
      } else {
        return '';
      }
    },
    ctaButton() {
      return this.diagnosisBlockData.diagnosis_cta;
    },
  },
  mounted() {
    document.addEventListener('scroll', this.menuHighlight);
  },
  methods: {
    openDiagnosticModel(ctaButtonText) {
        dataLayer.push({ //eslint-disable-line
        event: 'uaevent',
        event_name: 'site_load_service',
        ecommerce: 'undefined',
        eventCategory: 'augmented products',
        eventAction: `diagnosis::start`,
        eventLabel: ctaButtonText.toLowerCase(),
        service_name: 'diagnosis',
        service_category: 'diagnosis',
        cta_name: ctaButtonText.toLowerCase(),
      });
      if (this.diagnosisBlockData.diagnosis_iscta_redirect) {
        const link = this.ctaButton.Url;
        window.open(link, '_blank');
      } else {
        window.eventBus.$emit('openDiagnosticModel', true);
      }
    },
    menuHighlight() {
      const componentBlock = document.getElementById(this.componentId);
      if (componentBlock) {
        const checkOffset = componentBlock.offsetTop - 120;
        if (window.pageYOffset >= checkOffset) {
          window.eventBus.$emit('summary-menu-highlight', this.componentId);
        }
      }
    },
  },
};
</script>
